import React, { useEffect, useRef } from "react";
import clock from '../assets/images/clock.svg'

import lightGreenArrowOutline from '../assets/images/light-outline-arrow.svg'
import { useNavigate } from "react-router-dom";

import axios from "axios";
import IP from "../variable";

import { useQuery } from "react-query";
import useAxios from "../utils/useAxios";
import { formatTime } from "../utils/formatTime";


const AllInvestors = () => {

    const navigate = useNavigate()

    let api = useAxios()

    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        "all-meetings",
        async () => api.get(`${IP}/company/all-available-investors`),
        { cacheTime: 0 }
    );

    const investors = data?.data ?? []

    

    return (
        <>
            <div className="table-header">
               All Investors
            </div>

            {
                isLoading ?

                    <div className="placeholder-wave">
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>

                    </div>
                    :

                    investors.length > 0 ? 

                    investors.map((investor) => (

                        <div className="custom-card" key={investor.id}>
                   <span>
                       {investor?.name ?? '-'}
                   </span>

                   <span className="highlight">
                       {investor?.company ?? '-'}
                   </span>

                
                          

               </div>
                    ))

                       :

                    <div className="text-center">
                        <p>No Records Found</p>
                    </div>

            }
        </>
    )
}


export default AllInvestors;